import {Component, input} from '@angular/core';

@Component({
  selector: 'app-icon-account',
  imports: [],
  templateUrl: './icon-account.component.html'
})
export class IconAccountComponent {
  color = input('#4f4f4f');
}
